module.exports = __webpack_public_path__ + "static/media/4_square.1b7b134e.png";